import React, { Component, PropTypes } from 'react';
import { Form, Col, FormGroup, ControlLabel, FormControl, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config/config';
import ProgressBar from '../components/progressBar/ProgressBar';

const appUrlPath = `/${config.appUrlPath}`;

export class UpdatePassword extends Component {
  static propTypes = {
    username: PropTypes.string,
    password: PropTypes.string
  };

  constructor(props) {
    super(props);
    const agentCode = localStorage.getItem('agentCode');
    this.state = {
      username: agentCode,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      showModal: false,
      message: '',
      callSuccess: false,
      isLoading: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCurrentPassword = this.handleChangeCurrentPassword.bind(this);
    this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this);
    this.handleChangeConfirmPassword = this.handleChangeConfirmPassword.bind(this);
    this.validate = this.validate.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Update Password Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  handleChangeCurrentPassword(event) {
    this.setState({ currentPassword: event.target.value });
  }

  handleChangeNewPassword(event) {
    this.setState({ newPassword: event.target.value });
  }

  handleChangeConfirmPassword(event) {
    this.setState({ confirmPassword: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      this.setState({ isLoading: true })
      axios.post(`${appUrlPath}/updatePassword`, {
        currentPassword: this.state.currentPassword,
        newPassword: this.state.newPassword
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            message: 'Password has been updated successfully. Please login using the latest password.',
            showModal: true,
            callSuccess: true,
            isLoading: false
          })
        } else {
          this.setState({
            message: res.data.errMsg,
            showModal: true,
            callSuccess: false,
            isLoading: false
          });
        }
      })
      .catch((err) => {
        if (err) {
          this.setState({
            message: err.response.data.errMsg,
            showModal: true,
            callSuccess: false,
            isLoading: false
          });
        }
      });
    }
  }

  validate() {
    const currentPassword = this.state.currentPassword;
    const newPassword = this.state.newPassword;
    const confirmPassword = this.state.confirmPassword;
    let valid = false;

    if (!currentPassword || !newPassword || !confirmPassword) {
      this.setState({
        message: 'Current password, new password and confirm new password cannot be null.',
        showModal: true
      });
    } else if (currentPassword === newPassword) {
      this.setState({
        message: 'New password could not equal to current password',
        showModal: true
      });
    } else if (newPassword !== confirmPassword) {
      this.setState({
        message: 'New password does not match the confirm password.',
        showModal: true
      });
    } else {
      valid = true;
    }
    return valid;
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  close() {
    this.setState({ showModal: false }, () => {
      if (this.state.callSuccess) {
        axios.get(`${appUrlPath}/logout`)
        .then(() => {
          window.location = '/en/motorb2b/login';
        })
      }
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <h2 className="ebaoUtil__HeaderTwo">Update Password</h2>
        <div className="ebaoUtil__Form-60">
          <ul className="ebaoUtil__Form-ul">
            <li className="ebaoUtil__Form-li">Password must consist of 8 characters minimum for normal user or 15 characters minimum for admin user </li>
            <li className="ebaoUtil__Form-li">Password must not match any of your previous 6 passwords </li>
            <li className="ebaoUtil__Form-li">Password must not contain user name or &apos;AXA&apos; </li>
            <li className="ebaoUtil__Form-li">Password must contain characters from three of the following four categories: </li>
            <li className="ebaoUtil__Form-li">* Uppercase characters </li>
            <li className="ebaoUtil__Form-li">* Lowercase characters </li>
            <li className="ebaoUtil__Form-li">* Numbers </li>
            <li className="ebaoUtil__Form-li">* Special characters </li>
          </ul>
        </div>
        <Form horizontal onSubmit={this.handleSubmit}>
          <div className="EBaoHome__Container">
            <div className="ebaoUtil__Form-50">
              <FormGroup controlId="formUsername">
                <Col componentClass={ControlLabel} sm={3}>
                  Username
                </Col>
                <Col sm={9}>
                  <FormControl type="text"
                    value={this.state.username}
                    autoComplete="off"
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="formCurrentPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Current Password
                </Col>
                <Col sm={9}>
                  <FormControl type="password"
                    placeholder="Current Password"
                    value={this.state.currentPassword}
                    onChange={this.handleChangeCurrentPassword}
                    autoComplete="off"
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="formNewPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  New Password
                </Col>
                <Col sm={9}>
                  <FormControl type="password"
                    placeholder="New Password"
                    value={this.state.newPassword}
                    onChange={this.handleChangeNewPassword}
                    autoComplete="off"
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="formConfirmNewPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Confirm New Password
                </Col>
                <Col sm={9}>
                  <FormControl type="password"
                    placeholder="Confirm New Password"
                    value={this.state.confirmPassword}
                    onChange={this.handleChangeConfirmPassword}
                    autoComplete="off"
                  />
                </Col>
              </FormGroup>
            </div>
           <FormGroup controlId="buttonGroup">
             <div className="ebaoUtil__ButtonGroup">
               <button type="submit" className="btn btn-axa">Confirm</button>{' '}
               <button type="button" className="btn btn-axa" onClick={this.handleClick}>Back to Home</button>
             </div>
           </FormGroup>
          </div>
        </Form>
      </div>
    )
  }
}

export default UpdatePassword;



// WEBPACK FOOTER //
// ./src/app/pages/UpdatePassword.js